import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcImproveMark = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 10,
			cy: 10,
			r: 10,
			fill: "#454952"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 5.25,
			cy: 10.25,
			r: 1.25,
			fill: "#F2F4F8"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 9.75,
			cy: 10.25,
			r: 1.25,
			fill: "#F2F4F8"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 14.25,
			cy: 10.25,
			r: 1.25,
			fill: "#F2F4F8"
		})
	]
});
export default SvgIcImproveMark;
